import Login from './pages/login/Login';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './style/dark.scss';
import { useContext } from 'react';
import { DarkModeContext } from './context/darkModeContext';
import { AuthContext } from './context/AuthContext';
import { getAuth } from 'firebase/auth';
import useAutoLogout from './context/useAutoLogout';
import HomeWrapper from './components/HomeWrapper/HomeWrapper';
import ReadOnlyWrapper from './components/ReadOnlyWrapper/ReadOnlyWrapper';
import { SearchProvider } from './context/SearchContext';
import Loading from './components/Loading/Loading';

function App() {
  const { darkMode } = useContext(DarkModeContext);
  const { currentUser, isLoading, dispatch } = useContext(AuthContext);
  const auth = getAuth();

  const RequireAuth = ({ children }) => {
    if (isLoading) {
      return <Loading />;
    }
    return currentUser ? children : <Navigate to="/login" />;
  };

  const handleLogout = async () => {
    try {
      console.log('Auto-logout initiated');

      // Sign out from Firebase
      await auth.signOut();

      // Clear local state
      dispatch({ type: 'LOGOUT' });
      localStorage.removeItem('user');
      localStorage.removeItem('authToken');

      // Clear any other auth-related data
      localStorage.clear();

      console.log('Auto-logout completed');
    } catch (error) {
      console.error('Error during auto-logout:', error);
      // Force logout even if Firebase signOut fails
      dispatch({ type: 'LOGOUT' });
      localStorage.removeItem('user');
      localStorage.removeItem('authToken');
    }
  };

  // Only set up auto-logout if user is authenticated
  useAutoLogout(currentUser ? handleLogout : null, 10 * 60 * 1000);

  const isReadOnlyUser =
    currentUser?.staffData?.role === 'audit' ||
    currentUser?.staffData?.role === 'compliance';

  // Show loading while checking authentication state
  if (isLoading) {
    return <Loading />;
  }

  return (
    <SearchProvider>
      <div className={darkMode ? 'app dark' : 'app'}>
        <BrowserRouter>
          <Routes>
            <Route
              path="/login"
              element={currentUser ? <Navigate to="/" /> : <Login />}
            />
            <Route
              path="/*"
              element={
                <RequireAuth>
                  {isReadOnlyUser ? (
                    <ReadOnlyWrapper>
                      <HomeWrapper />
                    </ReadOnlyWrapper>
                  ) : (
                    <HomeWrapper />
                  )}
                </RequireAuth>
              }
            />
          </Routes>
        </BrowserRouter>
      </div>
    </SearchProvider>
  );
}

export default App;
